import {
	$$,
	ComponentOptions,
	IComponentBindings,
	IQuerySuccessEventArgs,
	Initialization,
	QueryEvents,
	ResultListEvents
	} from 'coveo-search-ui';

import { AtlasComponent } from "./../models/AtlasComponent";
import { IDynamicTextOptions, DynamicText } from "./../models/DynamicTextOptions";

export class TotalCountDetails extends AtlasComponent {
	static ID = "TotalCountDetails";
	static options: IDynamicTextOptions = {
		authorDefinedText: ComponentOptions.buildStringOption({
			defaultValue: "Showing {start} to {end} of {total}"
		})
	};
	public dynamicText: DynamicText;
	private resultList : Coveo.ResultList;
	private template: string = null;

	constructor(element: HTMLElement, options: IDynamicTextOptions, bindings: IComponentBindings) {
		super(element, TotalCountDetails.ID, bindings);
		this.dynamicText = new DynamicText(element, TotalCountDetails, options);

		//this.resultList = (Coveo.get($(".Coveo" + Coveo.ResultList.ID)[0], Coveo.ResultList) as Coveo.ResultList);

		// Event listeners
		this.bind.onRootElement(QueryEvents.querySuccess, (data: IQuerySuccessEventArgs) => this.handleQuerySuccess(data));
		//$$(this.resultList.element).on(ResultListEvents.newResultsDisplayed, this.update.bind(this));
	}

	protected handleQuerySuccess(data: IQuerySuccessEventArgs) {
		this.template = this.dynamicText.generateText({ start: 1, total: data.results.totalCountFiltered });

		if (this.resultList === undefined) {
			this.resultList = (Coveo.get($(".Coveo" + Coveo.ResultList.ID)[0], Coveo.ResultList) as Coveo.ResultList);

			$$(this.resultList.element).on(ResultListEvents.newResultsDisplayed, this.update.bind(this));
		}

		this.update();
	}

	protected update() {
		if (this.template === null) {
			return;
		}

		var totalDisplayed = this.resultList.getDisplayedResultsElements().length;
		if (totalDisplayed) {
			var value = this.template.replace("{end}", totalDisplayed.toString());
			this.domElement.setHtml(value);
			this.show();
		} else {
			this.hide();
		}
	}
}

Initialization.registerAutoCreateComponent(TotalCountDetails);



// WEBPACK FOOTER //
// ./src/source/Atlas.SEF.Feature.Common/Areas/AtlasCommon/Assets/Search/components/TotalCountDetails.ts